const CONSTANTS = {
  PRODUCT_HIERARCHY_ITEM_TYPES: {
    CATEGORY: "category",
    PRODUCT: "product",
  },
  REQUESTOR: "all-products"
}

module.exports = CONSTANTS
